// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1T9w0","top":"styles_top___mm-D","left":"styles_left__37ja3","description":"styles_description__Zf_M4"};